<template>
  <b-container fluid>
    <b-button variant="primary" class="mb-3" @click="abrirModal">➕ Nova Regra</b-button>

    <CalendarioEscala
      :semanas="semanas"
      @add-plantao="abrirModalComDia"
      @editar-plantao="editarPlantao"
    />

    <CadastroRegra
      :show-modal="mostrarModal"
      :regra-edicao="regraEdicao"
      @close="resetarModal"
      @salvar-regra="inserirRegra"
    />
  </b-container>
</template>

<script>
import CadastroRegra from './CadastroRegra.vue';
import CalendarioEscala from './CalendarioEscala.vue';

export default {
  components: {
    CalendarioEscala,
    CadastroRegra
  },
  data() {
    return {
      mostrarModal: false,
      regraEdicao: null,
      semanas: Array.from({ length: 5 }, () => ({
        seg: [], ter: [], qua: [], qui: [], sex: [], sab: [], dom: []
      }))
    };
  },
  methods: {
    abrirModal() {
      this.regraEdicao = null;
      this.mostrarModal = true;
    },
    abrirModalComDia({ semanaIndex, dayKey }) {
      this.regraEdicao = { semanaIndex, dayKey };
      this.mostrarModal = true;
    },
    editarPlantao({ semanaIndex, dayKey, plantaoIndex }) {
      const plantao = this.semanas[semanaIndex][dayKey][plantaoIndex];
      this.regraEdicao = {
        ...plantao,
        semanaIndex,
        dayKey,
        plantaoIndex
      };
      this.mostrarModal = true;
    },
    inserirRegra(regra) {
      if (regra.tipoEscala === 'Semanal') {
        regra.semanaIndex = null;
        regra.dayKey = null;
        regra.plantaoIndex = null;
      }

      const { semanaIndex, dayKey, plantaoIndex, remover } = regra;

      if (remover && typeof semanaIndex === 'number' && dayKey && typeof plantaoIndex === 'number') {
        this.semanas[semanaIndex][dayKey].splice(plantaoIndex, 1);
        return;
      }

      const plantaoBase = {
        tipo: regra.tipo,
        medico: regra.medico,
        inicio: regra.inicio,
        duracao: regra.duracao
      };

      if (typeof semanaIndex === 'number' && dayKey && typeof plantaoIndex === 'number') {
        this.$set(this.semanas[semanaIndex][dayKey], plantaoIndex, plantaoBase);
      } else if (typeof semanaIndex === 'number' && dayKey) {
        this.semanas[semanaIndex][dayKey].push(plantaoBase);
      } else if (regra.tipoEscala === 'Semanal') {
        this.semanas.forEach((semana) => {
          regra.diasSemana.forEach((dia) => {
            const chaveDia = dia.toLowerCase();
            if (semana[chaveDia]) {
              semana[chaveDia].push({ ...plantaoBase });
            }
          });
        });
      } else if (regra.tipoEscala === 'Trabalho x Descanso') {
        const dias = ['seg', 'ter', 'qua', 'qui', 'sex', 'sab', 'dom'];
        let diaIndex = 0;
        for (let s = 0; s < 5; s++) {
          const semana = this.semanas[s];
          for (let i = 0; i < 7; i++) {
            const dia = dias[(diaIndex + i) % 7];
            if ((diaIndex % (regra.intervalo + 1)) === 0) {
              semana[dia].push({ ...plantaoBase });
            }
            diaIndex++;
          }
        }
      }

      this.resetarModal()
    },
    resetarModal() {
      this.mostrarModal = false;
      this.regraEdicao = null;
    }
  }
};
</script>

<style scoped>
.grid-wrapper {
  display: flex;
}
.grid-weeks {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.grid-week-cell-header {
  height: 56px;
}
.grid-week-cell {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  font-weight: bold;
  background-color: #eef3f8;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding-left: 10px;
}
</style>
